export const TRIGGER_WORDS = [
  "death",
  "suicide",
  "kill",
  "selfharm",
  "self harm",
];
